export { default as ReportListTemplate } from './ReportListTemplate';
export { default as ReportEditTemplate } from './ReportEditTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/report/pages/index.js